import { Checkbox as AntdCheckbox } from "@empglabs/backoffice-ui-kit"

const Checkbox = props => {
  return <AntdCheckbox {...props} />
}

export default Checkbox
